<template>
  <Button
    :class="{ reverse }"
    :btn-style="btnStyle"
    :tag="tag"
    :size="btnSize"
    :dense="dense"
    :rounded="rounded"
    :circular="circular"
    :no-hover="noHover"
    @click="$emit('click', $event)"
  >
    <Icon :name="name" :size="size" :color="color" :type="type" />
    <slot />
  </Button>
</template>

<script>
import { toRefs, computed } from '@vue/composition-api';
import Button from '@/lego/components/buttons/Button.vue';
import Icon from '@/lego/components/icons/Icon.vue';

export default {
  name: 'IconButtonComponent',

  components: { Button, Icon },

  props: {
    name: {
      type: String,
      required: true,
    },

    size: {
      type: Number,
      default: 24,
    },

    color: {
      type: String,
      default: 'black',
    },

    type: {
      type: String,
      default: 'solid',
    },

    btnStyle: {
      type: String,
      default: 'ghost',
    },

    btnSize: {
      type: String,
      default: 'lg',
    },

    tag: {
      type: String,
      default: 'button',
    },

    dense: {
      type: Boolean,
      default: false,
    },

    rounded: {
      type: Boolean,
      default: false,
    },

    circular: {
      type: Boolean,
      default: false,
    },

    reverse: {
      type: Boolean,
      default: false,
    },

    noHover: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const { size } = toRefs(props);

    const iconStyle = computed(() => ({
      width: `${size.value}px`,
      height: `${size.value}px`,
    }));

    return { iconStyle };
  },
};
</script>

<style lang="postcss" scoped>
.button {
  @apply flex items-center justify-center gap-nano px-xxxs py-quark;

  &.reverse {
    @apply flex-row-reverse;
  }
}
</style>
